import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">麻豆在线</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.tagline}。{siteInfo.description.slice(0, 60)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/huiyuan-zhuanxiang" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">
                  会员专享
                </Link>
              </li>
              <li>
                <Link to="/category/zuixin-zixun" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">
                  最新资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信公众号：{siteInfo.wechat}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {siteInfo.year} 麻豆在线 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}